//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import PhantomTable from "@/pages/PhantomStock/components/PhantomTable.vue";
import PhantomForm from "@/pages/PhantomStock/components/PhantomForm.vue";
import { EventBus } from "@/event-bus.js";
import moment from "moment";
import FileSaver from "file-saver";
import { Feedback } from "@/utils/notify-toaster.js";

const TABLE_LIST_COLUMNS = [
  {
    name: "date",
    required: true,
    label: "Data",
    align: "left",
    field: (row) => row.reference_date,
    sortable: false,
  },
  {
    name: "store-code",
    align: "left",
    label: "Código de loja",
    field: (row) => row.store.code,
    sortable: false,
  },
  {
    name: "name",
    label: "Nome de loja",
    align: "left",
    field: (row) => row.store.name,
    sortable: false,
  },
  // TODO: Maybe implementar de futuro
  // {
  //   name: "seller",
  //   label: "Vendedor",
  //   align: "left",
  //   field: (row) => row.vendor,
  //   sortable: false,
  // },
  {
    name: "class",
    label: "Classe",
    align: "left",
    field: (row) => row.abc_class,
    sortable: false,
  },
  // { TODO: Para mais tarde
  //   name: "retailer-code",
  //   label: "Código de Retalhista",
  //   align: "left",
  //   field: (row) => (row.retailer_info ? row.retailer_info.sku : "N/A"),
  //   sortable: false,
  // },
  // {
  //   name: "retailer-description",
  //   label: "Descrição de Retalhista",
  //   align: "left",
  //   field: (row) => (row.retailer_info ? row.retailer_info.name : "N/A"),
  //   sortable: false,
  // },
  {
    name: "ean",
    label: "EAN",
    align: "left",
    field: (row) => row.product.ean,
    sortable: false,
  },
  {
    name: "supplier-description",
    label: "Descrição Fornecedor",
    align: "left",
    field: (row) => row.product.name,
    sortable: false,
  },
  {
    name: "last-sale-date",
    label: "Data da última venda",
    align: "left",
    field: (row) => row.last_sale_date,
    sortable: false,
  },
  {
    name: "stock",
    label: "Stock",
    align: "left",
    field: (row) => row.stock,
    sortable: false,
  },
  {
    name: "stock-in-transit",
    label: "Stock em trânsito",
    align: "left",
    field: (row) => row.in_transit_stock,
    sortable: false,
  },
  {
    name: "days-coverage",
    label: "Dias de cobertura",
    align: "left",
    field: (row) => row.coverage_day,
    sortable: false,
  },
  {
    name: "cardex-info",
    label: "Info Cardex",
    align: "left",
    field: (row) => row.cardex_info,
    sortable: false,
    icon: {
      conditional: true,
      false: {
        name: "mdi-close-circle-outline",
        label: "Inactivo",
        color: "red-4",
      },
      true: {
        name: "mdi-check-circle-outline",
        label: "Activo",
        color: "green-4",
      },
    },
  },
  {
    name: "flow",
    label: "Fluxo",
    align: "left",
    field: (row) => row.flux,
    sortable: false,
  },
  {
    name: "no-sale-days",
    label: "Dias sem venda",
    align: "left",
    field: (row) => row.days_since_last_sale,
    sortable: false,
  },
  {
    name: "reason-code",
    label: "Reason Code",
    align: "left",
    field: (row) => (row.reason_code ? row.reason_code.name : null),
    sortable: false,
  },
];

export default {
  name: "PhantomStock",
  components: {
    PhantomTable,
    PhantomForm,
  },
  mounted: function () {
    this.isLoading = true;
    this.date = null;

    BackendServices.getPhantomStockItems(null, null).then((response) => {
      this.recordsTotal = response.headers["x-total-count"];
      if (response.data["ghost_stocks"] != undefined) {
        this.tableData = [];
      } else {
        this.tableData = response.data;
      }
      this.isLoading = false;
    });

    this.$store.commit("setDatePickerState", true);
    EventBus.$on("rightDrawerQueryAction", this.executeQuertAction);
  },
  data: () => ({
    data: null,
    recordsTotal: 0,
    isLoading: false,
    tableColumns: TABLE_LIST_COLUMNS,
    tableData: [],
    productHierarchyElementId: null,
    storeHierarchyElementId: null,
    geoHierarchyElementId: null,
    productIds: null,
    storeIds: null,
    newPhantomClicked: false,
    separator: "horizontal",
    date: null,
    employeeIds: null,
  }),
  methods: {
    executeQuertAction: function () {
      this.askForData();
    },
    renderRightSide: function (event) {
      this.newPhantomClicked = true;
      this.data = event;
    },
    closeForm: function () {
      this.newPhantomClicked = false;
    },
    askForData: async function (event = null) {
      this.isLoading = true;
      let pagination = null;
      if (event == null) {
        pagination = null;
      } else {
        pagination = {
          page: event.pagination.page,
          rowsPerPage: event.pagination.rowsPerPage,
        };
      }

      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          employee_id: this.employeeIds,
        },
      };

      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }
      if (this.date) {
        drawerParams["filter"]["start_date"] = this.date._i;
        drawerParams["filter"]["end_date"] = this.date._i;
      } else {
        drawerParams["filter"]["start_date"] = null;
        drawerParams["filter"]["end_date"] = null;
      }
      let result = await BackendServices.getPhantomStockItems(
        pagination,
        drawerParams
      );
      this.recordsTotal = result.headers["x-total-count"];
      if (result.data["ghost_stocks"] != undefined) {
        this.tableData = [];
      } else {
        this.tableData = result.data;
      }
      this.isLoading = false;
      // BackendServices.getPhantomStockItems(event.pagination, event.filter).then(
      //   (response) => {
      //     this.recordsTotal = response.headers["x-total-count"];
      //     this.tableData = response.data;
      //     this.isLoading = false;
      //   }
      // );
    },
    exportPhantomStock() {
      Feedback.warning("Exportação iniciada.");
      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          employee_id: this.employeeIds,
        },
      };

      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }
      if (this.date) {
        drawerParams["filter"]["start_date"] = this.date._i;
        drawerParams["filter"]["end_date"] = this.date._i;
        BackendServices.downloadGhostStocks(drawerParams).then((response) => {
          FileSaver.saveAs(response.data, "PhantomStocks.xlsx");
        });
      } else {
        Feedback.error("Por favor escolha uma data antes de exportar.");
        drawerParams["filter"]["start_date"] = null;
        drawerParams["filter"]["end_date"] = null;
      }
      // BackendServices.downloadGhostStocks(drawerParams).then((response) => {
      //   const downloadUrl = window.URL.createObjectURL(
      //     new Blob([response.data])
      //   );
      //   const link = document.createElement("a");
      //   link.href = downloadUrl;
      //   link.setAttribute("download", "PhantomStocks.xlsx"); //any other extension
      //   document.body.appendChild(link);
      //   link.click();
      //   link.remove();
      // });
    },
    savePhantomStockEntry() {
      BackendServices.updatePhantomStockItem(this.data).then(() =>
        window.location.reload()
      );
    },
  },
  watch: {
    "$store.getters.getProductHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let productHierarchy = Object.values(
          this.$store.getters.getProductHierarchy
        ).filter((i) => i.length > 0);
        this.productHierarchyElementId =
          productHierarchy[productHierarchy.length - 1];
      },
    },
    "$store.getters.getStoreHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let storeHierarchy = Object.values(
          this.$store.getters.getStoreHierarchy
        ).filter((i) => i.length > 0);
        this.storeHierarchyElementId =
          storeHierarchy[storeHierarchy.length - 1];
      },
    },
    "$store.getters.getGeographyHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let geoHierarchy = Object.values(
          this.$store.getters.getGeographyHierarchy
        ).filter((i) => i.length > 0);
        this.geoHierarchyElementId = geoHierarchy[geoHierarchy.length - 1];
      },
    },
    "$store.getters.getSingleDate": {
      immediate: true,
      deep: true,
      handler: function () {
        this.date = moment(this.$store.getters.getSingleDate, "YYYY/MM/DD");
      },
    },
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.productIds) {
          this.productIds = [];
        }
        if (this.$store.getters.getProductList.length) {
          this.productIds = [];
          this.productIds = this.$store.getters.getProductList;
        } else {
          this.productIds = null;
        }
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.storeIds) {
          this.storeIds = [];
        }
        if (this.$store.getters.getStoreList.length) {
          this.storeIds = [];
          this.storeIds = this.$store.getters.getStoreList;
        } else {
          this.storeIds = null;
        }
      },
    },
    "$store.getters.getEmployeeList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.employeeIds) {
          this.employeeIds = [];
        }

        if (this.$store.getters.getEmployeeList.length) {
          this.employeeIds = [...this.$store.getters.getEmployeeList]
        } else {
          this.employeeIds = null;
        }
      },
    },
  },
};
